import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import {
  WarningOutlined,
  CheckSquareOutlined,
  BranchesOutlined,
  FileTextOutlined,
} from '@ant-design/icons';

export type KPICardType = 'danger' | 'primary' | 'default' | 'success';

export interface KPICardProps {
  title: string;
  value: number;
  type?: KPICardType;
}

const valueStyleByType: Record<KPICardType, React.CSSProperties> = {
  danger: { color: '#cf1322' },
  primary: { color: '#1677ff' },
  default: {},
  success: { color: '#389e0d' },
};

export const KPI: React.FC<KPICardProps> = ({ title, value, type = 'default' }) => (
  <Card size="small" style={{ height: '100%' }}>
    <Statistic title={title} value={value} valueStyle={valueStyleByType[type]} />
  </Card>
);

export interface WorkspaceKPIProps {
  overdueCount: number;
  taskCount: number;
  routeCount: number;
  applicationCount: number;
}

export const WorkspaceKPI: React.FC<WorkspaceKPIProps> = ({
  overdueCount,
  taskCount,
  routeCount,
  applicationCount,
}) => (
  <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
    <Col xs={24} sm={12} lg={6}>
      <Card size="small">
        <Statistic
          title="Просрочено"
          value={overdueCount}
          valueStyle={{ color: '#cf1322' }}
          prefix={<WarningOutlined />}
        />
      </Card>
    </Col>
    <Col xs={24} sm={12} lg={6}>
      <Card size="small">
        <Statistic
          title="Активных задач"
          value={taskCount}
          valueStyle={{ color: '#1677ff' }}
          prefix={<CheckSquareOutlined />}
        />
      </Card>
    </Col>
    <Col xs={24} sm={12} lg={6}>
      <Card size="small">
        <Statistic
          title="Маршруты (незаверш.)"
          value={routeCount}
          prefix={<BranchesOutlined />}
        />
      </Card>
    </Col>
    <Col xs={24} sm={12} lg={6}>
      <Card size="small">
        <Statistic
          title="Заявки (мои)"
          value={applicationCount}
          prefix={<FileTextOutlined />}
        />
      </Card>
    </Col>
  </Row>
);
